import React from 'react';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';
import ResetPasswordWithTokenDialogFooter from './Components/ResetPasswordWithTokenDialogFooter';
import ResetPasswordWithTokenDialogContent from './Components/ResetPasswordWithTokenDialogContent';
import ResetPasswordWithTokenDialogHeader from './Components/ResetPasswordWithTokenDialogHeader';

import './ResetPasswordWithTokenDialog.scss';

function ResetPasswordWithTokenDialog({
  close,
  responseStatus,
  trackAdobeAnalyticsError,
  setNewPassword,
  newPassword,
  setConfirmationPassword,
  confirmationPassword,
  submit,
}) {
  const [requestSent, setRequestSent] = React.useState(false);

  const handleSubmit = () => {
    if (!requestSent) {
      setRequestSent(true);
    }
    submit();
  };

  return (
    <GeneralDialogLayout
      selfClose={close}
      className="reset-password-with-token-dialog"
      size="md"
      layoutType="nothing"
      movable={false}
      header={<ResetPasswordWithTokenDialogHeader />}
      footer={<ResetPasswordWithTokenDialogFooter submit={handleSubmit} close={close} responseStatus={responseStatus} />}>
      <ResetPasswordWithTokenDialogContent
        requestSent={requestSent}
        newPassword={newPassword}
        confirmationPassword={confirmationPassword}
        setNewPassword={setNewPassword}
        setConfirmationPassword={setConfirmationPassword}
        responseStatus={responseStatus}
        trackAdobeAnalyticsError={trackAdobeAnalyticsError}
      />
    </GeneralDialogLayout>
  );
}

ResetPasswordWithTokenDialog.propTypes = {
  responseStatus: PropTypes.string,
  trackAdobeAnalyticsError: PropTypes.func.isRequired,
  newPassword: PropTypes.object.isRequired,
  setNewPassword: PropTypes.func.isRequired,
  confirmationPassword: PropTypes.object.isRequired,
  setConfirmationPassword: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
};

export default ResetPasswordWithTokenDialog;
